import dispatcher from '../dispatchers/dispatcher';

export function getArticles(hardRefresh) {
    if (hardRefresh) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'http://www.wblocks.com/hondaAPI/items/all', true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status === 200) {
                    var data = eval('(' + xhr.response + ')');
                    dispatcher.dispatch({
                        type: 'GET_ARTICLES',
                        articles: data.success.body.items
                    });
                } else if (xhr.status === 0) {
                    dispatcher.dispatch({
                        type: 'NO_NETWORK_CONNECTION'
                    });
                }
            }
        }
        xhr.send();
    }
}

export function deleteItem(itemId) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/items/delete/' + itemId, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                dispatcher.dispatch({
                    type: 'ARTICLE_DELETED',
                    itemId: itemId
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function addItem(name, description, linkUrl, price, currency, categoryId, brandId, hasPromo, callback) {
    var xhr = new XMLHttpRequest();
    let params = 'action=newItem&name=' + name + '&description=' + description + '&linkUrl=' + linkUrl + '&price=' + price + '&currency=' + currency + '&categoryId=' + categoryId + '&brandId=' + brandId + '&hasPromo=' + hasPromo;

    xhr.open('POST', 'http://www.wblocks.com/hondaAPI/items/create', true);

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'ARTICLE_CREATED',
                    item: data.success.body.item
                });
                callback();
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send(params);
}
export function addBrand(name, address, callback) {
    var xhr = new XMLHttpRequest();
    let params = 'action=newBrand&name=' + name + '&address=' + address;

    xhr.open('POST', 'http://www.wblocks.com/hondaAPI/brands/create', true);

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'BRAND_CREATED',
                    brand: data.success.body
                });
                callback();
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send(params);
}
export function addCategory(name, parentId, callback) {
    var xhr = new XMLHttpRequest();
    let params = 'action=newCategory&name=' + name + '&parentId=' + (parentId || 0);

    xhr.open('POST', 'http://www.wblocks.com/hondaAPI/categories/create', true);

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'CATEGORY_CREATED'
                });
                callback();
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send(params);
}

export function togglePromo(itemId, hasPromo, callback) {
    var xhr = new XMLHttpRequest();
    parseInt(hasPromo) > 0 ? hasPromo = 0 : hasPromo = 1;
    let params = 'action=togglePromo&itemId=' + itemId + '&hasPromo=' + hasPromo;

    xhr.open('POST', 'http://www.wblocks.com/hondaAPI/items/togglepromo', true);

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'CATEGORY_CREATED'
                });
                callback(hasPromo);
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send(params);
}

export function getBrands() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/brands/all', true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'GET_BRANDS',
                    brands: data.success.body.brands
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function deleteBrand(brandId) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/brands/delete/' + brandId, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                dispatcher.dispatch({
                    type: 'BRAND_DELETED',
                    brandId: brandId
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function getCategories() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/categories/all', true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'GET_CATEGORIES',
                    categories: data.success.body.categories
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}



// WEBPACK FOOTER //
// ./src/actions/TotemActions.js